export default "__VITE_ASSET__CoLufcaF__"